import { createContext, useContext } from 'react';
import { CustomerBillingInfoFormHandle } from 'components/billing/CustomerBillingForm/CustomerBillingInfoForm';

interface ICustomerInfoContext {
  customerInfoFormRef: React.RefObject<CustomerBillingInfoFormHandle> | null;
  setCustomerInfoFormRef: (ref: React.RefObject<CustomerBillingInfoFormHandle> | null) => void;
}

export const CustomerInfoContext = createContext<ICustomerInfoContext>({
  customerInfoFormRef: null,
  setCustomerInfoFormRef: () => {},
});

export const useCustomerInfoContext = () => useContext(CustomerInfoContext);
